import { createFrontendFeatureLoader } from '@backstage/frontend-plugin-api';

export const featuerLoader = createFrontendFeatureLoader({
  async *loader({ config }) {
    if (config.getOptionalBoolean('mcpChat.enabled')) {
      yield import('@backstage-community/plugin-mcp-chat/alpha');
    }

    if (config.getOptionalString('app.analytics.ga4.measurementId')) {
      if (config.getOptionalBoolean('app.analytics.ga4.weighted')) {
        yield import(
          '@platt/backstage-plugin-app-module-sample-weighted-analytics'
        );
      } else {
        yield import('@backstage-community/plugin-analytics-module-ga4/alpha');
      }
    }

    if (config.getOptionalString('platt.catalogOverviewLayout') === 'sample') {
      yield import(
        '@platt/backstage-plugin-catalog-module-sample-overview-layout'
      );
    }

    if (config.getOptionalBoolean('platt.copilotMetrics.enabled')) {
      yield import('@backstage-community/plugin-copilot/alpha');
    }
  },
});
